import script from "./CalendarioAdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioAdminView.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioAdminView.vue?vue&type=style&index=0&id=29f2a020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f2a020"]])

export default __exports__